import { render, staticRenderFns } from "./Report-lab.vue?vue&type=template&id=33beacc8"
import script from "./Report-lab.js?vue&type=script&lang=js&external"
export * from "./Report-lab.js?vue&type=script&lang=js&external"
import style0 from "./Report-lab.vue?vue&type=style&index=0&id=33beacc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports